export default __webpack_public_path__ + "static/media/29.3d1711c5.mp3";